import { render, staticRenderFns } from "./UserRequisites.vue?vue&type=template&id=25b11481&scoped=true&"
import script from "./UserRequisites.vue?vue&type=script&lang=js&"
export * from "./UserRequisites.vue?vue&type=script&lang=js&"
import style0 from "./UserRequisites.vue?vue&type=style&index=0&id=25b11481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b11481",
  null
  
)

export default component.exports